/**
 * @description Player Type= Chromeless or Full
 * <p>CHROMELESS - VTG player only (custom skin use case)</p>
 * <p>FULL - Full player (VTG player + Avia JS UI bundle)</p>
 */
export enum PlayerType {

	/**
	 * @description Chromeless player (VTG bundle)
	 */
	CHROMELESS = 'chromeless',

	/**
	 * @description Full player (VTG player + Avia JS UI bundle)
	 * @type {string}
	 */
	FULL = 'full'

}